import { createElement } from 'react';
const CollapseSelectorItem = ({ children, title, icon }) => {
    return createElement('div', { className: 'collapse-selector-content-inner' }, children);
};
CollapseSelectorItem.displayName = 'CollapseSelectorItem';
export default CollapseSelectorItem;
